export class PlanningFormStatus {
  transactionAndTestedPartyForm: boolean;
  financialDetialsForm: boolean;
  taxRateForm: boolean;
  riskSettingsForm: boolean;
  projectionReady: boolean;
}
